import React from "react";
import { Entity, SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

const UserProfileListLoader = ({ itemsNumber = 10 }) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-px-4 tw-py-2 tw-h-full tw-pb-2">
      <div className="tw-flex tw-items-center tw-px-2 tw-h-8 tw-mb-1">
        <SkeletonLoader className="tw-w-36" />
      </div>
      <Entity.Group
        className="project_list active-projects list"
        renderAs="list"
      >
        {[...Array(itemsNumber)].map((_, index) => (
          <div
            key={index}
            className={classNames(
              "c-entity-card-list tw-flex tw-h-14 tw-mb-1 tw-gap-4 tw-pl-4 tw-pr-3 tw-items-center tw-rounded-lg"
            )}
          >
            <Entity.Property className="entity-property-name">
              <SkeletonLoader className="tw-w-full" />
            </Entity.Property>
            <Entity.Property
              className="entity-property-client"
              listWidth="160px"
              visibleFromBreakpoint="md"
            >
              <SkeletonLoader className="tw-w-1/3 tw-mb-0.5" />
              <SkeletonLoader className="tw-w-full" />
            </Entity.Property>
            <Entity.Property
              className="entity-property-info tw-flex-col tw-items-start"
              listWidth="134px"
              visibleFromBreakpoint="md"
            >
              <SkeletonLoader className="tw-w-full" />
            </Entity.Property>
            <div className="c-entity-card">
              <Entity.Property
                className="entity-property-label"
                visibleFromBreakpoint="lg"
                listWidth="180px"
              >
                <SkeletonLoader className="tw-w-full" />
              </Entity.Property>
            </div>
            <Entity.Property
              className="tw-flex tw-flex-row tw-justify-end"
              listWidth="56px"
            >
              <SkeletonLoader className="tw-w-full" />
            </Entity.Property>
          </div>
        ))}
      </Entity.Group>
    </div>
  );
};

UserProfileListLoader.propTypes = {
  itemsNumber: PropTypes.number,
};

export default UserProfileListLoader;
